<template>
    <div class="river-info-container">
        <!-- 遮罩层 -->
        <div v-if="loading" class="loading-overlay"
            style="display: flex; justify-content: center; align-items: center; height: 100vh;">
            <van-loading size="32px" color="#1989fa" class="spinning">加载中...</van-loading>
        </div>
        <div class="content-wrapper">
            <!-- 顶部横幅 -->
            <div class="banner-section">
                <img :src="require('@/assets/img/slogan.png')" class="banner-image">
            </div>

            <!-- 地表水质类别说明 -->
            <div class="section-title" @click="goToWaterQualityCategories">
                <span>地表水质类别说明</span>
                <van-icon name="arrow" />
            </div>

            <div class="water-quality-image" @click="goToWaterQualityCategories">
                <img :src="require('@/assets/img/water-quality.png')"
                    v-img-fallback="require('@/assets/icon/noimage.png')" class="quality-image">
            </div>

            <!-- 水质列表区域 -->
            <div class="water-lists-container">
                <!-- 河道信息 -->
                <WaterQualityList title="河道" :list="indexData.riverQualitys" :loading="loading" />

                <!-- 湖泊信息 -->
                <WaterQualityList title="湖泊" :list="indexData.lakeQualitys" :loading="loading" />

                <!-- 海湾信息 -->
                <WaterQualityList title="海湾" :list="indexData.bayQualitys" :loading="loading" />
            </div>
        </div>
    </div>
</template>

<script>
import WaterQualityList from '@/components/WaterQualityList';
import { interface_pubkey1, interface_prikey1, app_key, appOrPC, ipType } from '@/utils/config'
import { get } from '@/utils/api'
export default {
    components: {
        WaterQualityList,
    },
    data() {
        return {
            indexData: {
                riverQualitys: [],
                lakeQualitys: [],
                bayQualitys: [],
            },
            loading: true,
        };
    },
    methods: {
        // 获取首页信息
        async getIndexData() {
            if (appOrPC) {
                let that = this, extraData = {
                    header: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "App-Version-Code": "v2.0.0"
                    }
                }
                vaildInterfacefn(
                    "hhwzzcsesonq",
                    "rcshhwtyjkV0",
                    JSON.stringify({
                        ipType: ipType,
                        methodType: "get",
                        methodName: "api/app/common/indexData",
                        platform: "android"
                    }),
                    "1",
                    extraData
                ).then((value) => {
                    if (value == false) {
                        return;
                    } else {
                        try {
                            const de_value = JSON.parse(value)
                            if (de_value.code == 200 && de_value.success) {
                                that.indexData = de_value.data;
                                console.log("获取首页信息indexData：", that.indexData)
                            } else {
                                that.$toast.fail(de_value.message || '获取首页信息失败');
                            }
                        } catch (error) {
                            that.getIndexData()
                        }
                    }
                })
            } else {
                const param = {
                    platform: "android"
                };
                const res = await get('/common/indexData', param);
                if (res.code == 200 && res.success) {
                    this.indexData = res.data;
                    console.log("获取首页信息indexData：", this.indexData)
                } else {
                    this.$toast.fail(res.message || '获取首页信息失败');
                }
            }
            this.loading = false;
        },
        goToWaterQualityCategories() {
            this.$router.push({
                name: 'WaterQualityCategories',
            })
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.user.userInfo;
        }
    },
    watch: {
        userInfo: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.getIndexData();
                }
            }
        }
    }
};
</script>

<style scoped>
.river-info-container {
    min-height: 100vh;
    background-color: #f5f7fa;
    position: relative;
}

.content-wrapper {
    /* 导航栏高度 */
    padding-bottom: 20px;
}

.banner-section {
    width: 100%;
    overflow: hidden;
}

.banner-image {
    width: 100%;
    display: block;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    background-color: #ffffff;
    margin-top: 12px;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.section-title span {
    position: relative;
    padding-left: 12px;
}

.section-title span::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background-color: #0081ff;
    border-radius: 2px;
}

.water-quality-image {
    padding: 0 12px 16px;
    background-color: #ffffff;
    border-radius: 0 0 8px 8px;
    margin-bottom: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.quality-image {
    width: 100%;
    border-radius: 4px;
    display: block;
}

.water-lists-container {
    padding: 0 12px;
    margin-top: 16px;
}

/* 覆盖 Vant 导航栏样式 */
:deep(.van-nav-bar) {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

:deep(.van-nav-bar__title) {
    color: #ffffff;
    font-weight: 500;
}

:deep(.van-icon) {
    color: #ffffff !important;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .section-title {
        font-size: 14px;
        padding: 12px;
    }
}
</style>
